export default __webpack_public_path__ + "static/media/oslavy-narozeniny.90a15c17.jpg";